export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11717.726b55d2.jpg";